import React from 'react'
import './hoverSidebar.css'
import {FaPeopleRoof, FaBlogger, FaPeopleGroup} from "react-icons/fa6"
import {PiHandshakeFill} from "react-icons/pi"


const HoverSidebar = ({onmouseLeave, clickedbutn}) => {

  const handleMouseLeave = () =>{
    onmouseLeave(false)
  }

  const handleClick = (e) =>{
    clickedbutn(e.target.id)
  }
  
  return (
    <div className='hover-sidebar-container'
      onMouseLeave={handleMouseLeave}
    >
        <ul>
            <li id='aboutus' onClick={handleClick}>
              <FaPeopleGroup className='sidebar-icon'/>
              <span>About Us</span>
              <div className='butn-cover' id='aboutus' onClick={handleClick}/>
            </li>

            <li id='contractform' onClick={handleClick}>
              <PiHandshakeFill className='sidebar-icon'/>
              <span>Contract Form</span>
              <div className='butn-cover' id='contract' onClick={handleClick}/>
            </li>

            <li id='executive' onClick={handleClick}>
              <FaPeopleRoof className='sidebar-icon'/>
              <span>Executive</span>
              <div className='butn-cover' id='executive' onClick={handleClick}/>
            </li>

            <li  id='blog' onClick={handleClick}>
              <FaBlogger className='sidebar-icon'/>
              <span>Blog</span>
              <div className='butn-cover' id='blog' onClick={handleClick}/>
            </li>
        </ul>
    </div>
  )
}

export default HoverSidebar